// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Tabs__List {\n  border-bottom: 1px solid #ccc;\n  padding-left: 0;\n  margin-bottom: 20px; }\n", ""]);
// Exports
module.exports = exports;
